import { render, staticRenderFns } from "./couponProductList.vue?vue&type=template&id=13f065b6&scoped=true&"
import script from "./couponProductList.vue?vue&type=script&lang=js&"
export * from "./couponProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f065b6",
  null
  
)

export default component.exports